<template>
  <!-- Cancel ticket START -->
  <div class="cancel-ticket" style="display: block;"><!-- +/- display: block; -->
    <div class="calcBox-fon"></div>
    <div class="calcBox">

      <div class="clHeader">{{getname(state)}}</div>
      <div class="calcBox-container">
        <div class="clTitle">{{$t('enternum')}}</div>
        <form action="" @submit.once.prevent="PayCard()">
          <input class="tablo" id="tbl" type="text" v-model="cardnum" />
          <button class="btn2cl clEnter" @click.once.prevent="PayCard()">APPLY</button>
        </form>
        <!--<div class="clTitle">Enter your ticket number</div>-->
      </div>

      </div>

    <modal :active="show_error" 
      v-on:modalClosed="show_error=false" 
      class="payment-modal"><errpop :state="states" :msg="msgs"/>
    </modal>

  </div>
  <!-- Cancel ticket STOP -->
</template>

<script>
import errpop from '@/views/TextPOPup.vue'
import modal from '@/components/Modal.vue'

export default{
  name: 'Payment',
  props: ['state'],
  data: ()=>{
    return {
      show_error: false,
      cardnum: '',
      states: '',
      msgs: ""
    }
  },
  components: {
    modal, errpop
  },
  mounted() {
    document.getElementById("tbl").focus();
    document.body.addEventListener('keypress', (e) => {
      if (e.key === 'Enter') this.PayCard()
    });
  },
  methods: {
    getname(name){
      if(name == 'Return') {
        let res = this.$t('return') + ' ' + this.$t('ticket');
        return res;
      }
      if(name == "Pay") return this.$t('payment')
    },
    error(msg, state){
      this.states = this.$t(state);
      this.msgs = msg;
      this.show_error = true;
    },
    PayCard(){
    	 return this.$store.dispatch('apirequestPOST', {name: 'bet/check', token: this.$store.state.user.token, data: {Code: this.cardnum, request: this.state, GameID: this.$store.state.game.GameID}}).then((response)=>{
        if(response.data.Error) {
          return this.error(this.$t("cardid"), "errors");
        }

        let x = "" + this.$t(response.data.Result);
        if(response.data.Result == "returncard" || response.data.Result == "wincard"){
          x = "" + this.$t(response.data.Result) + response.data.Amount;
        }
        return this.error(x, "success")
      });
    }
  }
};
 </script>

